module.exports = __webpack_public_path__ + "static/media/planName.cbffc89e.svg";